import { Component } from '@angular/core';

import { EnumeratedPermission } from "../../models/enumerated.permission.model";
import { Claim } from "../../models/claim.model";
import { SelectorBase } from "./selector-base.component";

@Component({
    selector: 'admin-permission-selector',
    templateUrl: "./selector-base.component.html",
    styleUrls: ['./selector-base.component.scss'],
    standalone: false
})
export class PermissionsSelector extends SelectorBase<EnumeratedPermission, Claim> {

  compareElements(a: EnumeratedPermission, b: EnumeratedPermission): number {
    return a.display > b.display ? 1 : -1;
  }

  elementEqualsOutput(element: EnumeratedPermission, output: Claim): boolean {
    return output.type === element.type && output.value === element.value;
  }

  elementToOutput(element: EnumeratedPermission): Claim {
    let c = new Claim();
    c.type = element.type;
    c.value = element.value;
    return c;
  }

  getDisplay(element: EnumeratedPermission): string {
    return element.display;
  }
}